import { REALMS } from '../../constants/constants'
import { CrystalIcon, JadeIcon, JewelIcon, CommonIcon, UncommonIcon, RareIcon, LegendaryIcon, MythicIcon } from '../Icons'
import './HeroSummary.css'

const rarityIcons = [<CommonIcon />, <UncommonIcon />, <RareIcon />, <LegendaryIcon />, <MythicIcon />]

const HeroSummary = ({ hero }) => {
    const icon =
        hero.originRealm === REALMS.serendale.id ? (
            <JewelIcon />
        ) : hero.originRealm === REALMS.crystalvale.id ? (
            <CrystalIcon />
        ) : (
            <JadeIcon />
        )

    return (
        <>
            <div className="hero-summary-name">
                {hero.name}
                <br />
                {icon} #{hero.displayId}
            </div>

            <div className="hero-summary-details">
                <div className="hero-class">
                    <div className="primary">{hero.mainClass}</div>
                    <div className="secondary">{hero.subClass}</div>
                </div>
                <div className="hero-rarity">{rarityIcons[hero.rarity]}</div>
                <div className="hero-level">
                    <div className="primary">Level {hero.level}</div>
                    <div className="secondary">Gen {hero.generation}</div>
                </div>
            </div>
        </>
    )
}

export default HeroSummary
